export default __webpack_public_path__ + "alberta-incontinence.33b3460a2f63fa2a367e.svg";